import { useHistory } from "react-router-dom";
import { Button } from "../../components/Button/Button";
import animation from "./404-animation.gif";
import styles from "./NotFoundPage.module.scss";

export const NotFoundPage: React.FunctionComponent = () => {
  const history = useHistory();

  const onBackClick = () => {
    history.push("/");
  };

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.text}>Stranica nije pronađena</h1>
      <img src={animation} alt="Not Found Animation" className={styles.image} />

      <Button type="default" onClick={onBackClick}>
        Nazad
      </Button>
    </div>
  );
};
